import {CurrencyPipe, NgClass, NgIf, CommonModule} from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Product } from '../../models/product.model';
import { APP_ROUTES } from '../../app.routes.definition';
import {
    getMarketplaceProductCallToActionLabel,
    getMarketplaceProductTypeLabel
} from '../../shared/utils/marketplace-product-labels';

@Component({
    selector: 'product-card',
    standalone: true,
    imports: [NgClass, NgIf, RouterModule, CommonModule, CurrencyPipe],
    templateUrl: './product-card.component.html',
    styleUrl: './product-card.component.scss',
})
export class ProductCardComponent {
    @Input({required: true}) product!: Product;

    productPath = APP_ROUTES.MARKETPLACE_PRODUCT;

    isFeaturedProduct(product = this.product): boolean {
        return product.originalPrice != null || product.isFeaturedProduct;
    }

    getProductTypeLabel(product = this.product): string {
        return getMarketplaceProductTypeLabel(product);
    }

    getProductCallToActionLabel(product = this.product): string {
        return getMarketplaceProductCallToActionLabel(product);
    }

}
